const STATES = {
  IDLE: 'idle',
  POSTING_INCREMENT: 'posting-increment',
  POSTING_DECREMENT: 'posting-decrement',
};

const quantitySelector = () => ({
  max: 20,
  states: STATES,
  state: STATES.IDLE,

  async postNewQuantity(newQty, isDecrement) {
    try {
      let withGift = this.$store.cart.cartData.items.find(
        item => item.product_id === window.GIFT_WITH_PURCHASE_PRODUCT_ID && item.final_price === 0 && item.properties?.__isGiftWithPurchase === "GWP"
      );
      let withCollectionGift = this.$store.cart.cartData.items.find(
        item => item.product_id === window.COLLECTION_GWP_PRODUCT_ID && item.properties?.__collectionFreeGift === "__collectionFreeGift"
      );

      let itemToRemove = this.$store.cart.cartData.items.find(
        item => item.key === this.cartItem.key
      );

      const updates = {
        [this.cartItem.key]: newQty,
      };

      if(isDecrement && withGift && this.totalForProgressCalculation - itemToRemove.price / 100 < window.GIFT_WITH_PURCHASE_MINIMUM_CART_VALUE){
        updates[withGift.key] = 0;
      }
      const gwpProduct = this.$store.cart.cartData.items.find(
        item => item.properties?.__isFreeGift === "__isFreeGift" && item.properties?.__productIdRequired == itemToRemove.product_id && item.final_price === 0
      );

      if(isDecrement && withCollectionGift){
        const percentageTotal = this.$store.cart.percentageReachedCollectionGwp;
        const percentageRemoved = (itemToRemove.price / 100) / this.$store.cart.collectionGWP?.gwpProductAmount?.value * 100;
        if(percentageTotal - percentageRemoved < 100){
          updates[withCollectionGift.key] = 0;
        }
      }

      if(isDecrement && gwpProduct){
        if(newQty - gwpProduct.quantity < 0){
          updates[gwpProduct.key] = gwpProduct.quantity - 1;
        }
      }
      if(!isDecrement && gwpProduct){
        updates[gwpProduct.key] = gwpProduct.quantity + 1;
      }

      await this.$store.cart.updateCart({updates});
    } catch (error) {
      alert(error.message);
    } finally {
      this.state = STATES.IDLE;
    }
  },

  increment() {
    if (this.state !== STATES.IDLE) return;
    if (this.cartItem.quantity === this.max || this.cartItem.quantity == 10) {
      if (this.cartItem.quantity) this.cartItem.quantity = 10;
      return;
    }

    const newQty = this.cartItem.quantity + 1;
    this.state = STATES.POSTING_INCREMENT;
    this.postNewQuantity(newQty,false);
  },

  async decrement() {
    if (this.state !== STATES.IDLE) return;
    const newQty = this.cartItem.quantity - 1;
    this.state = STATES.POSTING_DECREMENT;
    this.postNewQuantity(newQty,true);
  },
  get totalForProgressCalculation() {
    return (() => {
    const cartItems = this.$store.cart.cartData?.items || [];

    const hasFreeGift = cartItems.some(
      item =>
        item.product_id === window.GIFT_WITH_PURCHASE_PRODUCT_ID &&
        item.final_price === 0 && item.properties?.__isGiftWithPurchase === "GWP"
    );

    let excludedUnits = 0;

    return cartItems.reduce((acc, item) => {
      const isExcludedProduct =
        item.product_id === window.GIFT_BOX_PRODUCT_ID ||
        item.product_id === window.GIFT_WITH_PURCHASE_PRODUCT_ID;

      const quantity = item.quantity;
      const price = item.final_price;

      if (isExcludedProduct && excludedUnits > 0 && !hasFreeGift) {
        const unitsToExclude = Math.min(quantity, excludedUnits);
        const unitsToInclude = quantity - unitsToExclude;
        return acc + unitsToInclude * price;
      }

      return acc + quantity * price;
    }, 0) / 100;
  })();
  }
});

export default quantitySelector;
